module.exports = __webpack_public_path__ + "static/image_hero_home-82ffe4090b47b93cca13c188ae87c329.png";